import { render, staticRenderFns } from "./FieldValue.vue?vue&type=template&id=0222368a"
import script from "./FieldValue.vue?vue&type=script&lang=js"
export * from "./FieldValue.vue?vue&type=script&lang=js"
import style0 from "./FieldValue.vue?vue&type=style&index=0&id=0222368a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports